export const categories = [
  {
    name: "development",
    id: "c1",
  },
  {
    name: "business",
    id: "c2",
  },
  {
    name: "finance & accounting",
    id: "c3",
  },
  {
    name: "IT & software",
    id: "c4",
  },
  {
    name: "office productivity",
    id: "c5",
  },
  {
    name: "personal development",
    id: "c6",
  },
  {
    name: "design",
    id: "c7",
  },
  {
    name: "marketing",
    id: "c8",
  },
  {
    name: "lifestyle",
    id: "c9",
  },
  {
    name: "photography & video",
    id: "c10",
  },
  {
    name: "health & fitness",
    id: "c11",
  },
  {
    name: "music",
    id: "c12",
  },
  {
    name: "teaching & academics",
    id: "c13",
  },
];
